/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import doxpolicyPortal from '@dox/policy-portal';
import doxarchivesUi from '@dox/archives-ui';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.3","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/projects/prc/frontend/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/opt/projects/prc/frontend/core/packages/volto-slate/package.json","basePath":"/opt/projects/prc/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@dox/policy-portal","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/projects/prc/frontend/packages/policy-portal/src","hasServerConfig":false,"packageJson":"/opt/projects/prc/frontend/packages/policy-portal/package.json","basePath":"/opt/projects/prc/frontend/packages/policy-portal","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"@dox/policy-portal/*":["./src/*"]}],"addons":[],"razzleExtender":"/opt/projects/prc/frontend/packages/policy-portal/razzle.extend.js"},{"name":"@dox/archives-ui","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/projects/prc/frontend/packages/archives-ui/src","hasServerConfig":false,"packageJson":"/opt/projects/prc/frontend/packages/archives-ui/package.json","basePath":"/opt/projects/prc/frontend/packages/archives-ui","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"@dox/archives-ui/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, doxpolicyPortal, doxarchivesUi];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
